import { render } from "./Create-digitize-link.vue?vue&type=template&id=e6d505e2"
import script from "./Create-digitize-link.vue?vue&type=script&lang=js"
export * from "./Create-digitize-link.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__